<h2 mat-dialog-title>{{ nomination.nomineeName || nomination.entryTypeText }}</h2>

<mat-dialog-content>
  <p class="detail-subtitle">
    {{ nomination.entryTypeText }}
    @if (nomination.positionTitle) {
      <span> - {{ nomination.positionTitle }}</span>
    }
  </p>

  <table mat-table [dataSource]="rows">
    <ng-container matColumnDef="label">
      <th mat-header-cell *matHeaderCellDef>Field</th>
      <td mat-cell *matCellDef="let element">{{ element.label }}</td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>Value</th>
      <td mat-cell *matCellDef="let element">{{ element.value }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
